;(function () {
  var initialized = false
  /** @type {{ modalEl: Element, form: HTMLFormElement, triggerEl: HTMLElement, pf: Element, key: string, didAction?: boolean } | null} */
  var pending = null

  function qsPickerScriptInRoot(root, key) {
    if (!root || !key) return null
    var nodes = root.querySelectorAll('[data-iw-plan-picker-cart]')
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i].getAttribute('data-iw-plan-picker-key') === key) return nodes[i]
    }
    return null
  }

  function readCartPayload(root, key) {
    var script = qsPickerScriptInRoot(root, key)
    if (!script || !script.textContent) return null
    try {
      return JSON.parse(script.textContent.trim())
    } catch (err) {
      return null
    }
  }

  function isSellingPlanAllowed(payload, planId) {
    if (!payload || planId == null || planId === '') return false
    var idStr = String(planId)
    var plans = payload.sellingPlans
    if (plans && plans.length) {
      for (var i = 0; i < plans.length; i++) {
        if (String(plans[i].id) === idStr) return true
      }
    }
    return String(payload.firstSellingPlanId) === idStr
  }

  function getCartDrawer() {
    return document.querySelector('cart-notification') || document.querySelector('cart-drawer')
  }

  function buildCartAddConfig(formData) {
    var config
    if (typeof fetchConfig === 'function') {
      config = fetchConfig('javascript')
      config.headers['X-Requested-With'] = 'XMLHttpRequest'
      delete config.headers['Content-Type']
    } else {
      config = {
        method: 'POST',
        headers: {
          Accept: 'application/javascript',
          'X-Requested-With': 'XMLHttpRequest',
        },
      }
    }
    var cart = getCartDrawer()
    if (cart && typeof cart.getSectionsToRender === 'function') {
      formData.append(
        'sections',
        cart.getSectionsToRender().map(function (sec) {
          return sec.id
        })
      )
      formData.append('sections_url', window.location.pathname)
      if (typeof cart.setActiveElement === 'function') {
        cart.setActiveElement(document.activeElement)
      }
    }
    config.body = formData
    return { config: config, cart: cart }
  }

  function publishCartSafe(evt, payload) {
    try {
      if (typeof publish === 'function' && typeof evt !== 'undefined')
        publish(evt, payload)
    } catch (e2) {}
  }

  /** Own interval so IW plan picker countdown never clashes with sticky `sticky-atc-ab.js`. */
  var iwCountdownId = null

  function clearIwPlanPickerCountdown() {
    if (iwCountdownId !== null) {
      clearInterval(iwCountdownId)
      iwCountdownId = null
    }
  }

  function pad2Countdown(num) {
    return ('0' + Math.max(0, num)).slice(-2)
  }

  function startIwPlanPickerCountdown(modal) {
    clearIwPlanPickerCountdown()
    if (!modal || !modal.querySelector) return
    var minEl = modal.querySelector('[data-atc-countdown-min]')
    var secEl = modal.querySelector('[data-atc-countdown-sec]')
    if (!minEl || !secEl) return
    var raw = modal.getAttribute('data-iw-countdown-seconds')
    if (raw === null || raw === '') return
    var total = parseInt(raw, 10)
    if (isNaN(total) || total < 0) total = 300

    function paint() {
      var m = Math.floor(total / 60)
      var s = total % 60
      minEl.textContent = pad2Countdown(m)
      secEl.textContent = pad2Countdown(s)
    }

    paint()
    iwCountdownId = window.setInterval(function () {
      total -= 1
      if (total < 0) total = 0
      paint()
    }, 1000)
  }

  /** @param trigger {HTMLElement} */
  function setTriggerLoading(trigger, on) {
    if (!trigger) return
    if (on) {
      trigger.classList.add('loading')
      trigger.setAttribute('aria-busy', 'true')
      trigger.disabled = true
      var sp = trigger.querySelector('.loading-overlay__spinner')
      if (sp) sp.classList.remove('hidden')
    } else {
      trigger.classList.remove('loading')
      trigger.removeAttribute('aria-busy')
      trigger.disabled = false
      var sp2 = trigger.querySelector('.loading-overlay__spinner')
      if (sp2) sp2.classList.add('hidden')
    }
  }

  function hideModal(modal) {
    if (modal && typeof modal.hide === 'function') modal.hide()
  }

  /** Normal product-form AJAX submit (one-time, no selling_plan in form). */
  function submitProductForm(form, triggerEl) {
    setTriggerLoading(triggerEl, false)
    if (!form) return
    if (typeof form.requestSubmit === 'function') form.requestSubmit()
    else form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }))
  }

  function onTriggerClickCapture(e) {
    var btn = e.target.closest('[data-iw-plan-picker-trigger]')
    if (
      !btn ||
      btn.hasAttribute('disabled') ||
      btn.getAttribute('aria-disabled') === 'true'
    )
      return
    var pf = btn.closest('[data-iw-plan-picker-root]')
    if (!pf) return

    var key = pf.getAttribute('data-iw-plan-picker-key')
    if (!key) return

    var payload = readCartPayload(pf, key)
    if (!payload || payload.available === false || !payload.sellingPlans || !payload.sellingPlans.length)
      return

    e.preventDefault()
    e.stopPropagation()

    var modalId = btn.getAttribute('data-iw-plan-picker-modal-id')
    var modal = modalId && document.getElementById(modalId)
    if (!modal || typeof modal.show !== 'function') return

    pending = {
      modalEl: modal,
      key: pf.getAttribute('data-iw-plan-picker-for-match') || '',
      pf: pf,
      form: pf.querySelector('form'),
      triggerEl: btn,
      didAction: false,
    }

    clearIwPlanPickerCountdown()
    modal.show(btn)
    startIwPlanPickerCountdown(modal)
  }

  function onModalActions(e) {
    var actBtn = e.target.closest('[data-iw-plan-picker-action]')
    if (!actBtn) return
    var modal = actBtn.closest('[data-iw-plan-picker-modal]')
    if (!modal || !pending || pending.modalEl !== modal) return

    var action = actBtn.getAttribute('data-iw-plan-picker-action')
    if (action !== 'upgrade' && action !== 'decline') return

    var expectedFor = modal.getAttribute('data-iw-plan-picker-for') || ''
    if (pending.key && expectedFor && pending.key !== expectedFor) return

    e.preventDefault()
    clearIwPlanPickerCountdown()
    pending.didAction = true

    var key = pending.pf && pending.pf.getAttribute('data-iw-plan-picker-key')
    var payload = pending.pf ? readCartPayload(pending.pf, key || '') : null
    var form = pending.form
    var trigger = pending.triggerEl
    pending = null

    if (action === 'decline') {
      hideModal(modal)
      submitProductForm(form, trigger)
      return
    }

    var sel = modal.querySelector('[data-iw-plan-picker-select]')
    var raw = sel && sel.value ? String(sel.value).trim() : ''

    hideModal(modal)

    if (
      !raw ||
      !payload ||
      typeof routes === 'undefined' ||
      !routes.cart_add_url ||
      !isSellingPlanAllowed(payload, raw)
    ) {
      submitProductForm(form, trigger)
      return
    }

    setTriggerLoading(trigger, true)

    var formData = new FormData()
    formData.append('id', String(payload.variantId))
    formData.append('quantity', '1')
    formData.append('selling_plan', raw)

    var baked = buildCartAddConfig(formData)

    fetch(String(routes.cart_add_url), baked.config)
      .then(function (r) {
        return r.json()
      })
      .then(function (response) {
        if (response.status) {
          publishCartSafe(
            typeof PUB_SUB_EVENTS !== 'undefined' ? PUB_SUB_EVENTS.cartError : undefined,
            {
              source: 'quick-add-plan-picker-atc',
              productVariantId: String(payload.variantId),
              errors: response.errors || response.description,
              message: response.message,
            }
          )
          return
        }
        var c = baked.cart
        if (!c && window.routes && routes.cart_url) {
          window.location.href = routes.cart_url
          return
        }
        publishCartSafe(
          typeof PUB_SUB_EVENTS !== 'undefined' ? PUB_SUB_EVENTS.cartUpdate : undefined,
          {
            source: 'quick-add-plan-picker-atc',
            productVariantId: String(payload.variantId),
            cartData: response,
          }
        )
        if (c && typeof c.renderContents === 'function') {
          c.renderContents(response)
        }
        if (c && c.classList && c.classList.contains('is-empty'))
          c.classList.remove('is-empty')
      })
      .catch(console.error)
      .finally(function () {
        setTriggerLoading(trigger, false)
      })
  }

  /** Overlay / ESC: same as Decline → product-form submit (only if our modal lost `open`). */
  document.body.addEventListener(
    'modalClosed',
    function () {
      clearIwPlanPickerCountdown()
      var p = pending
      if (!p || p.didAction) return
      var modalEl = p.modalEl
      var form = p.form
      var triggerEl = p.triggerEl
      requestAnimationFrame(function () {
        if (pending !== p || !p || p.didAction) return
        if (modalEl && modalEl.hasAttribute('open')) return
        p.didAction = true
        pending = null
        submitProductForm(form, triggerEl)
      })
    },
    false
  )

  function init() {
    if (initialized) return
    initialized = true
    document.addEventListener('click', onTriggerClickCapture, true)
    document.addEventListener('click', onModalActions, false)
  }

  if (document.readyState === 'loading')
    document.addEventListener('DOMContentLoaded', init)
  else init()
})()
